const requestAnimationFrame = window.requestAnimationFrame;

export class QueuedModel {
  queued: boolean = false;
  constructor() {
    this.doUpdate = this.doUpdate.bind(this);
  }
  queue() {
    this.queued = true;
  }
  doUpdate() {}
}

class FlowController {
  beforeRenderQueue: QueuedModel[] = [];
  renderQueue: QueuedModel[] = [];

  constructor() {
    this.doBeforeRender = this.doBeforeRender.bind(this);
    this.doRender = this.doRender.bind(this);
    this.update();
  }

  addBeforeRender(model: QueuedModel) {
    this.beforeRenderQueue.push(model);
  }

  removeBeforeRenderModel(model: QueuedModel) {
    const index = this.beforeRenderQueue.indexOf(model);
    if (index !== -1) {
      this.beforeRenderQueue.splice(index, 1);
    }
  }

  addRender(model: QueuedModel) {
    this.renderQueue.push(model);
  }

  removeRender(model: QueuedModel) {
    const index = this.renderQueue.indexOf(model);
    if (index !== -1) {
      this.renderQueue.splice(index, 1);
    }
  }

  update() {
    requestAnimationFrame(this.doBeforeRender);
  }

  doBeforeRender() {
    for (let model of this.beforeRenderQueue) {
      if (model.queued) {
        model.doUpdate();
        model.queued = false;
      }
    }
    this.doRender();
  }

  doRender() {
    for (let model of this.renderQueue) {
      if (model.queued) {
        model.doUpdate();
        model.queued = false;
      }
    }

    this.update();
  }
}

export default new FlowController();
